<template>
	<div class="ComponentCard">
		<v-tooltip location="top" open-delay="500" color="white" max-width="300px" content-class="tooltip-arrow-top dashboard-tooltip" :disabled="!tooltipText">
			<template v-slot:activator="{ props }">
				<v-badge bordered color="error" :content="badgeCount" v-if="badgeCount>0" />
				<v-card flat class="card" :class="{ 'draggableCard': isCustomiseDashboard, locked, 'no-pointer': locked && !tooltipText }" color="transparent" @mousedown="start()" @mouseup="stop()" v-bind="props">
          <template v-if="locked"><div class="corner-lock" data-cy="corner-lock"></div><v-icon class="corner-lock__icon" icon="mdi-lock-outline" size="16" /></template>
					<div class="d-flex align-center img-container" style="height: 70%" :style="{'background':componentCard.fields.colour.de + ' !important'}">
						<v-img style="opacity:0.5;" :height="imgSize" :width="imgSize" :src="getAssetUrl(componentCard.fields.icon.de)"/>
					</div>
					<div class="title d-flex align-center justify-center px-1 text-center label text-grey-darken-2">
						<span :style="{ 'font-size': fontSize}">{{componentCard.fields.title[selectedLocale]}}</span>
					</div>
				</v-card>
			</template>
			<span>{{ tooltipText }}</span>
		</v-tooltip>
	</div>
</template>

<script>
import Common from '@/mixins/Common.vue'
import ContractExecutive from '../../../../api2/src/modules/contract/ContractExecutive';

export default {
	name: 'ComponentCard',
	mixins: [ Common ],
	props: {
		componentCard: Object,
		isCustomiseDashboard: Boolean,
    locked: Boolean,
    lockedTooltip: String
	},

  data () {
    return {
      badgeCount: 0,
      startCustomiseTimer: 0,
    }
  },

  computed: {
    imgSize () {
      switch (this.$vuetify.display.name) {
        case 'xs': return 50
        case 'sm': return 60
        case 'md': return 70
        case 'lg': return 80
        case 'xl': return 80
        default: return 100
      }
    },
    fontSize () {
      switch (this.$vuetify.display.name) {
        case 'xs': return '8pt'
        case 'sm': return '8pt'
        case 'md': return '10pt'
        case 'lg': return '12pt'
        case 'xl': return '14pt'
        default: return '14pt'
      }
    },
    tooltipText () {
      return this.locked ? (this.lockedTooltip || '') : this.componentCard.fields.tooltip ? this.componentCard.fields.tooltip[this.selectedLocale] : ''
    }
  },
  
  watch: {
		'$vuetify.locale.current': function() {
			this.selectedLocale = this.$vuetify.locale.current
		}
	},

  async mounted() {
    let url = ''
    let requestParams = ''
    let userId = ''
    let lookupCount = false

    switch (this.componentCard.fields.link.de) {
      case "/serviceProviders":
        lookupCount = true
        url = '/serviceprovider-count'
        requestParams = `?status=pending,reapprove&client=${this.$store.state.selectedClient.sys.id}`

        if (this.$store.state.isImpersonation === true && this.$store.state.selectedServiceProvider.fields.tags?.de) {
          requestParams += `&tags=${this.$store.state.selectedServiceProvider.fields.tags.de}`
        }
        if (this.userIsOperator && this.$store.state.isImpersonation === false && !this.$store.state.loggedInUser.fields.canSeeObjectsWithTags.de.find(x => x === "ALL")) {
          requestParams += `&tags=${this.$store.state.loggedInUser.fields.canSeeObjectsWithTags.de}`
        }
        break

      case "/services":
        lookupCount = true
        url = '/product-count'
        requestParams = `?status=pending&client=${this.$store.state.selectedClient.sys.id}`
        if (this.$store.state.isImpersonation === true) {
          requestParams += `&serviceProviderId=${this.$store.state.selectedServiceProvider.sys.id}`
        }
        if (this.userIsOperator && this.$store.state.isImpersonation === false && !this.$store.state.loggedInUser.fields.canSeeObjectsWithTags.de.find(x => x === "ALL")) {
          requestParams += `&tags=${this.$store.state.loggedInUser.fields.canSeeObjectsWithTags.de}`
        }
        break

      case "/messages":
        lookupCount = true
        url = '/message-count'
        userId = this.$store.state.isImpersonation === true ? this.$store.state.selectedServiceProvider?.fields?.userAccount?.de?.sys?.id : this.$store.state.loggedInUser.sys.id
        requestParams = `?userId=${userId}`
        break

      case "/contractManagement":
        lookupCount = true
        url = '/api2/getContractorsWithoutContract'
        break
    }

	if (lookupCount === true) {
		if (url.startsWith('/api2/')) {
			let contractExecutive = new ContractExecutive(this)
			const methodName = url.replace('/api2/', '')
			const res = await contractExecutive[methodName](this.$store.state.selectedClient.sys.id)
			this.badgeCount = res
		} else {
			const res = await this.$httpGet(url, requestParams)
			this.badgeCount = res.count
		}
	}
  },

  methods: {
    start() {
      if (this.locked) {
        return
      }
      if (!this.isCustomiseDashboard) {
        if (!this.startCustomiseTimer) {
          this.startCustomiseTimer = setTimeout(this.startDraggable, 1000)
        }
      }
    },

    async stop() {
      if (this.locked) {
        clearTimeout(this.startCustomiseTimer)
        return
      }
      if (!this.isCustomiseDashboard) {
        clearTimeout(this.startCustomiseTimer)
        await this.$store.commit('setSelectedComponent', this.componentCard)
        this.$emit('view-component')
      
      } else {
        clearTimeout(this.$store.state.timer)
        var timerId = setTimeout(this.stopDraggable, 5000)
        await this.$store.commit('setTimer', timerId)
      }
    },

    startDraggable() {
      if (!this.isCustomiseDashboard) {
        clearTimeout(this.startCustomiseTimer)
        this.startCustomiseTimer = null
        this.$emit('start-draggable')
      }
    },

    stopDraggable() {
      if (this.isCustomiseDashboard) {
        this.$emit('stop-draggable')
      }
    }
  }
}
</script>

<style scoped>
.ComponentCard { width: 100%; height: 100%; box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.3); border-radius: 10px; }
.card { height: 100%; width: 100%; cursor: pointer; }
.card.no-pointer { pointer-events: none; }
.title { height: 30%; line-height: 1em; }

.label {
  width: 100% !important;
  background-color: white !important;
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}
.img-container {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
  position: relative;
}
.containerCorner {
  display: inline-block;
  position: absolute;
  z-index: 99;
  width: 13px;
  height: 16px;
  left: 0;
  top: 0;
}
.containerLock {
  display: inline-block;
  position: absolute;
  z-index: 100;
  width: 65px;
  height: 65px;
  left: 0;
  top: 0;
  margin-left: 10px;
  margin-top: 10px;
}
@keyframes shake {
  from {
    transform: rotate(-1.5deg);
  }
  to {
    transform: rotate(1.5deg);
  }
}

.draggableCard {
  animation-name: shake;
  animation-duration: 0.1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

.ComponentCard .corner-lock {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 48px solid #00688F;
  border-right: 48px solid transparent;
  border-top-left-radius: 4px;
  z-index: 1;
}

.ComponentCard .corner-lock__icon {
  position: absolute;
  top: 6px;
  left: 6px;
  color: #fff;
  z-index: 2;
}

.ComponentCard .v-card.locked .img-container::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.50);
}
</style>

<style>
.ComponentCard .v-badge { padding: 0 !important; position: absolute !important; right: 35px; top: 35px; border-width: 0; }
.ComponentCard .v-badge--bordered .v-badge__badge::after { box-shadow: 0 0 20px rgba(0, 0, 0, 0.3); }
.ComponentCard .v-tooltip > .v-overlay__content { color: black !important; background: white !important; opacity: 1 !important; padding: 10px 15px !important; z-index: 999 !important; box-shadow: 0 0 20px rgba(0, 0, 0, 0.2); }
.v-tooltip > .v-overlay__content.dashboard-tooltip { 
  padding: 16px; 
  background: white;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.037px;
  color: #000;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.10);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.30), 0 1px 3px 1px rgba(0, 0, 0, 0.15);
}
</style>
